exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".co-crew-carousel{display:flex!important;align-items:center!important}.slick-list{width:100%!important}.bg-entry-box{background-repeat:no-repeat;background-position:50%;max-width:100%}.bg-entry-box>*{width:203px;height:195px;max-width:100%;display:block;margin-left:auto;margin-right:auto}.entry-preview-image{width:203px;height:195px;-o-object-fit:cover;object-fit:cover;padding:3.5%}.bg-video-play-before--square:before{background-size:80px}.bg-video-play-before--square:hover:before{background-size:100px}", ""]);

// exports
